// type == 1 已签到 type == 2 未签到 type == 3 点击签到 type == 4 未到签到时间

<template>
  <div class="item" :class="`item_${itemData.type}`" @click="sing">
    <template v-if="itemData.type == 1">
      <div class="day">第{{ itemData.day }}天</div>
      <img src="@/assets/image/icon_001.webp" alt="" srcset="">
      <div>已签</div>
    </template>
    <template v-if="itemData.type == 2">
      <div class="day">第{{ itemData.day }}天</div>
      <img src="@/assets/image/icon_002.webp" alt="" srcset="">
      <div>未签</div>
    </template>
    <template v-if="itemData.type == 3">
      <div class="day">第{{ itemData.day }}天</div>
      <img src="@/assets/image/icon_003.webp" alt="" srcset="">
      <div>点击签到</div>
    </template>
    <template v-if="itemData.type == 4">
      <div class="day">第{{ itemData.day }}天</div>
    </template>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    itemData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {};
  },
  created() {},
  computed: {},
  methods: {
    sing() {
      if(this.itemData.type == 3){
        this.$emit("sing");
      }
    }
  },
};
</script>

<style scoped lang="scss">
.item {
  padding: 8px;
  text-align: center;
  border: 1px solid #ffffff;
  color: #262626;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  height: 114px;
  padding: 14px 0;
  img{
    width: 26px;
    height: 26px;
  }
  &_1 {
  }
  &_2 {
    color: #999999;
  }
  &_3 {
    background: #0062FF;
    color: #ffffff;
    img{
      width: 21.82px;
      height: 30px;
    }
    cursor: pointer;
  }
  &_4 {
  }
}
</style>
